import React from 'react';
import { Crown } from 'lucide-react';

const PremiumBadge = ({ size = 18, className = "" }) => {
  return (
    <div 
      className={`
        inline-flex items-center justify-center 
        bg-gradient-to-tr from-amber-400 via-yellow-300 to-amber-200
        dark:bg-gradient-to-tr dark:from-yellow-400 dark:via-yellow-200 dark:to-yellow-500
        text-amber-900 dark:text-yellow-900 
        rounded-full 
        shadow-sm dark:shadow-[0_0_10px_rgba(253,224,71,0.4)]
        border border-yellow-500/30
        ${className}
      `}
      title="Premium Member"
    >
      <Crown 
        size={size} 
        strokeWidth={2.5} 
        className="fill-yellow-600/30 dark:fill-yellow-200/50" 
      />
    </div>
  );
};

export default PremiumBadge;